import white from '../../src/images/0.png'
import blue from '../../src/images/1.png'
import black from '../../src/images/2.png'
import red from '../../src/images/3.png'
import green from '../../src/images/4.png'
import azorius from '../../src/images/Azorius.png'
import dimir from '../../src/images/Dimir.png'
import rakdos from '../../src/images/Rakdos.png'
import selesnya from '../../src/images/Selesnya.png'
import orzhov from '../../src/images/Orzhov.png'
import izzet from '../../src/images/Izzet.png'
import simic from '../../src/images/Simic.png'
import golgari from '../../src/images/Golgari.png'
import gruul from '../../src/images/Gruul.png'
import boros from '../../src/images/Boros.png'

export const allyBoxMana = [
    0, 1, 2, 3, 4, 10, 11, 12, 13, 14
]

export const enemyBoxMana = [
    0, 1, 2, 3, 4, 15, 16, 17, 18, 19
]

export const untappedPackMana = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9
]

export const tappedPackMana = [
    10, 11, 12, 13, 14, 15, 16, 17, 18, 19
]

export const shockMana = [
    10, 11, 12, 13, 14, 15, 16, 17, 18, 19
]

export const allyShockBox = [
    0, 1, 2, 3, 4, 10, 11, 12, 13, 14
]

export const enemyShockBox = [
    0, 1, 2, 3, 4, 15, 16, 17, 18, 19
]

export const imageArray = [
    white,
    blue,
    black,
    red,
    green,
    white,
    blue,
    black,
    red,
    green,
    azorius,
    dimir,
    rakdos,
    gruul,
    selesnya,
    izzet,
    simic,
    golgari,
    orzhov,
    boros


]

export const manaList = [
    // Untapped Mana
    'w',
    'u',
    'b',
    'r',
    'g',
    'w',
    'u',
    'b',
    'r',
    'g',
    // 5 Allied Tapped Mana
    'wu',
    'ub',
    'br',
    'rg',
    'wg',
    // 5 Enemy Tapped Mana
    'ur',
    'ug',
    'bg',
    'wb',
    'wr',
]

export const altTextList = [
    // Untapped Mana
    'White Mana',
    'Blue Mana',
    'Black Mana',
    'Red Mana',
    'Green Mana',
    'White Mana',
    'Blue Mana',
    'Black Mana',
    'Red Mana',
    'Green Mana',
    // 5 Allied Tapped Mana
    'White/Blue Mana',
    'Blue/Black Mana',
    'Black/Red Mana',
    'Red/Green Mana',
    'White/Green Mana',
    // 5 Enemy Tapped Mana
    'Blue/Red Mana',
    'Blue/Green Mana',
    'Black/Green Mana',
    'White/Black Mana',
    'White/Red Mana',
]